import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';


@Component({
    selector: 'main-page',
    templateUrl: 'main.page.html',
    styleUrls: ['main.page.scss'],
})
export class MainPage implements OnInit {
    ngOnInit() { 
    }

    getInnerWidth() {
        return window.innerWidth;
    }

    getInnerHeight() {
        return window.innerHeight;
    }

    getScreenWidth() {
        return screen.width;
    }

    getScreenHeight() {
        return screen.height;
    }

    getOrientation() {
        return window.orientation;
    }

    getMediaQuery1() {
        return window.matchMedia('(max-width: 780px)').matches;
    }

    getMediaQuery2() {
        return window.matchMedia('((max-width: 780px) and (orientation: landscape))').matches;
    }

    getMediaQuery3() {
        return window.matchMedia('((max-width: 780px) and (orientation: 90))').matches;
    }

    getMediaQuery4() {
        return window.matchMedia('((max-width: 780px) and (orientation: portrait))').matches;
    }

    getMediaQuery5() {
        return window.matchMedia('((max-width: 780px) and (orientation: 0))').matches;
    }

    getUserAgent() {
        return navigator.userAgent;
    }
}
